
export const refreshJsBridge = () => {
  // eslint-disable-next-line
  require('../app/jsBridge');
  window.jsBridge.ycTabClick({
    success: function () {
      window.location.reload();
    },
    fail: function (result) {
      console.log(JSON.stringify(result));
    }
  });
};

// 主软件 拨打电话
export const autoTel = (tel) => {
  window.jsBridgeV2.tel({
    tel: tel,
    success: (result) => {
      console.log(JSON.stringify(result));
    },
    fail: (result) => {
      console.log(JSON.stringify(result));
    }
  });
};
/**
  * 打开原生页面
  */
export const openNativePage = (url) => {
  require('../app/jsBridge');
  window.jsBridgeV2.openNativePage({
    url: url,
    success: (result) => {
      console.log(JSON.stringify(result));
    },
    fail: (result) => {
      console.log(JSON.stringify(result));
    }
  });
};

/**
* 移动终端浏览器版本信息
*/
export const checkMobileVersions = () => {
  let u = navigator.userAgent;
  return { // 移动终端浏览器版本信息
    trident: u.indexOf('Trident') > -1, // IE内核
    presto: u.indexOf('Presto') > -1, // opera内核
    webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器
    iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
    iPad: u.indexOf('iPad') > -1, // 是否iPad
    pad: u.indexOf('iPad') > -1 || u.indexOf('pad') > -1,
    webApp: u.indexOf('Safari') === -1 // 是否web应该程序，没有头部与底部
  };
};

// const crypto = require('crypto');
let timer = null;
/**
 * 获取cookie
 * @param {String} 要获取的cookie的name
 * @return {Object} 返回对应cookie的value
 */
export const getCookie = (name) => {
  let arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
  if (arr != null) {
    return decodeURI(arr[2]);
  }
};

/**
 * 设置cookie
 * @param {String} name cookie的name
 * @param {String} value cookie的value
 * @param {Number} t cookie的保存时间（小时为单位）
 */
export const setCookie = (name, value, t) => {
  if (t) {
    let exp = new Date();
    exp.setTime(exp.getTime() + t * 60 * 60 * 1000);
    document.cookie = name + '=' + encodeURI(value) + ';expires=' + exp.toGMTString() + ';path=/';
  } else {
    document.cookie = name + '=' + encodeURI(value) + ';path=/';
  }
};

export const setCookie2 = (name, value, t) => {
  if (t) {
    let exp = new Date();
    exp.setTime(exp.getTime() + t * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + exp.toGMTString();
  } else {
    document.cookie = name + '=' + value + ';path=/';
    }
};

/**
 * 删除cookie
 * @param {String} name cookie的name
 */
export const removeCookie = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + ';path=/';
  }
};
export const removeCookie2 = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + ';path=/;domain=.autohome.com.cn';
  }
};

/**
 * 判断是否嵌入App
 * @param {String} name cookie的name
 */
export const webApp = {
  checkAutoHomeApp() {
    let ua = window.navigator.userAgent.toUpperCase();
    return /auto_/i.test(ua)
  },
  // 是否嵌入违章app
  checkViolatApp: function() {
    let currentUA = window.navigator.userAgent.toUpperCase();
    return /wz_ios|wz_android/ig.test(currentUA)
  },
  // 是否嵌入违章app
  wzAndroid: function() {
    let currentUA = window.navigator.userAgent.toUpperCase();
    return /wz_android/ig.test(currentUA)
  },
 // 微信环境判断
  isWx () {
    let ua = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger';
  },
  // 是否嵌入微信小程序
  isWxProgram() {
    let UA = window.navigator.userAgent.toLowerCase();
    return (UA.match(/miniProgram/i) && UA.match(/miniProgram/i)[0] === 'miniprogram' || window.__wxjs_environment === 'miniprogram');
  },
  // UA判断是否是autohome的app
  uaIsAutohome() {
    let UA = window.navigator.userAgent.toLowerCase();
    return /autohomeapp/g.test(UA);
  },
};
/**
 * 正则校验手机号
 *
 */
export const checkMobilePhone = (mobilePhone) => {
  if (/^[1][34578][0-9]{9}$/.test(mobilePhone)) {
    return true;
  }
  return false;
};

/*
* 获取url参数
 */
export const getUrlParam = (str) => {
  let paramObj = {};
  let url = str || window.location.href;
  let paramstr = url.split('?');
  if (paramstr.length > 1) {
    let params = paramstr[1].split('&');
    for (let i = 0; i < params.length; i++) {
      let param = params[i].split('=');
      paramObj[param[0]] = decodeURIComponent(decodeURIComponent(param[1]));
    }
  }
  return paramObj;
};

/*
* 获取url参数2
 */
export const getUrlParam2 = (url, name) => {
  let str = '';
  if (url.indexOf('?') !== -1) {
    str = url.substr(url.indexOf('?') + 1);
  } else {
    return url;
  }
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let r = str.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

// 平滑滚动
export const scrollSmoothTo = (element, direction, scrollTo, time) => {
  const scrollFrom = parseInt(element[direction], 10);
  let i = 0;
  const runEvery = 5; // run every 5ms
  const scrollTo1 = parseInt(scrollTo, 10);
  const element1 = element;
  let time1 = time;
  time1 /= runEvery;
  const interval = setInterval(() => {
    i += 1;
    element1[direction] = ((scrollTo1 - scrollFrom) / time1) * i + scrollFrom;
    if (i >= time1) {
      clearInterval(interval);
    }
  }, runEvery);
}

/**
 * 设置title
 * @param {String} title title名称
 */
export const setTitle = (title) => {
  document.title = title;
  const mobile = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(mobile)) {
    var iframe = document.createElement('iframe');
    iframe.style.visibility = 'hidden';
    // 替换成站标favicon路径或者任意存在的较小的图片即可
    // iframe.setAttribute('src', 'https://x.autoimg.cn/cfw/yc/images/favicon.ico');
    const iframeCallback = function () {
      setTimeout(function () {
        iframe.removeEventListener('load', iframeCallback);
        document.body.removeChild(iframe);
      }, 0);
    };
    iframe.addEventListener('load', iframeCallback);
    document.body.appendChild(iframe);
  }
  if (webApp.uaIsAutohome()) {
    // eslint-disable-next-line
    require('../app/jsBridge');
    window.jsBridgeV2.actionbarinfoTitle({
      title: title,
      addmenulist: [],
      stablemenulist: [],
      success: (res) => {
        console.log(res, '动态设置title---success');
      },
      fail: (res) => {
        console.log(res, '动态设置title---fial');
      }
    });
  }
};
